import React from 'react';

import * as styles from './ScrollToTop.module.css';

import Arrow from '@components/SVG/Arrow';

const ScrollToTop = (): JSX.Element => {
	return (
		<a
			href="#header"
			aria-label="Scroll to the top of the website"
			className={styles.box}>
			<Arrow className={styles.arrow} />
		</a>
	);
};

export default ScrollToTop;
